import { Select } from "antd";
import React from "react";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import {
  BELARUS_REGION,
  OTHERS_REGION,
  RegionType,
} from "../../calculators/clientsFeeCalculator";

interface Props {
  placeholder?: string;
  onChange: (value: RegionType) => void;
  size?: SizeType;
  className?: string;
  defaultValue?: "belarus" | "others";
}

const SelectRegion: React.FC<Props> = ({
  placeholder,
  onChange,
  size,
  className,
  defaultValue,
}) => (
  <Select
    placeholder={placeholder}
    onChange={onChange}
    size={size}
    className={className}
    allowClear
    defaultValue={defaultValue}
  >
    <Select.Option value={BELARUS_REGION}>Belarus</Select.Option>
    <Select.Option value={OTHERS_REGION}>Other</Select.Option>
  </Select>
);

export default SelectRegion;
